import React from 'react';

export const PillBorder: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <div className="border-1 py-1 px-2 rounded-full border-gray-300 bg-white">
      {children}
    </div>
  );
};
